import { render, staticRenderFns } from "./TabItem.vue?vue&type=template&id=8a724c72&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"
import style0 from "./TabItem.vue?vue&type=style&index=0&id=8a724c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a724c72",
  null
  
)

export default component.exports